import { DataChart } from '../components/ChartWrapper'

export function getCardChartData(
  data: DataChart,
  groupIndex = 5
): Record<string, DataChart> {
  const grouped: Record<string, DataChart> = {}
  const rows = [...data]

  for (const row of rows) {
    const groupKey =
      row.length > groupIndex ? String(row[groupIndex]) : 'undefined'

    if (!grouped[groupKey]) {
      grouped[groupKey] = []
    }

    const copiedRow: DataChart[number] = [...row]
    copiedRow.splice(groupIndex, 1)
    if (groupKey !== 'undefined') {
      grouped[groupKey].push(copiedRow)
    }
  }

  return grouped
}
